module.exports = "/_next/static/images/logo-4e8ba1614908838103f6d7b7ca226c99.svg";